import ENV from './config';
export default {
  ...ENV,
  REACT_APP_BASE_API_URL: 'https://server-staging.oraidex.io',
  REACT_APP_WS_URL: 'wss://server-staging.oraidex.io/websocket/',
  REACT_APP_SENTRY_ENVIRONMENT: 'staging'
};
